import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsSelect as Select } from './src/Select.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(Select);
export const FsSelect = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-select.js.map